module.exports = __webpack_public_path__ + "static/img/适配机型banner.059ce22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/适配机型banner.png
// module id = VlWV
// module chunks = 0